import Stocks from './components/Stocks';

export default Stocks;
